import { render, staticRenderFns } from "./IsAutoBrand.vue?vue&type=template&id=12de5ef4"
import script from "./IsAutoBrand.vue?vue&type=script&lang=ts"
export * from "./IsAutoBrand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports